import { render, staticRenderFns } from "./CreateShoppingCartInput.vue?vue&type=template&id=3ad6670e&scoped=true"
import script from "./CreateShoppingCartInput.vue?vue&type=script&lang=js"
export * from "./CreateShoppingCartInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6670e",
  null
  
)

export default component.exports